import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-currentplan-changeplan-box',
  templateUrl: './currentplan-changeplan-box.component.html',
  styleUrls: ['./currentplan-changeplan-box.component.sass']
})
export class CurrentplanChangeplanBoxComponent implements OnInit {
  @Input() currentPlan;
  @Input() plazo_equipo;
  @Input() serv_ad;
  @Input() actualPrice;
  @Input() descr_plan;
  @Input() type_plan;
  @Input() ins_eq;

  constructor() { }

  ngOnInit() {
  }

}
